var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"monthbutton"},[_c('MiniButton',_vm._g({},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }